<template>
  <v-form class="form" ref="form">
    <v-layout row>
      <v-flex xs10>
        <content-field
          label="Enter category"
          v-model="categoryPlaceholder"
        />
      </v-flex>
    </v-layout>
    <v-btn
      class="btn_submit"
      color="success"
      :disabled="$v.$invalid"
      @click="updateCategoryPlaceholder"
    >
      Update placeholder
    </v-btn>
  </v-form>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'
  import { mapActions, mapGetters } from 'vuex'
  import { pathOr } from 'ramda'

  export default {
    name: "PlaceholderTextSettings",
    data () {
      return {
        categoryPlaceholder: ''
      }
    },
    validations: {
      categoryPlaceholder: {
        required
      }
    },
    computed: {
      ...mapGetters([
        'staticContent'
      ]),
      currentPlaceholder () {
        return pathOr('', ['metadata', 'RACategoryPlaceholder', 'content'], this.staticContent.find(this.isPlaceholderExists))
      }
    },
    watch: {
      currentPlaceholder: {
        immediate: true,
        handler () {
          this.categoryPlaceholder = this.currentPlaceholder
        }
      }
    },
    methods: {
      ...mapActions([
        'updatePlaceholderValue',
        'fetchStaticContent'
      ]),
      async updateCategoryPlaceholder () {
        this.$v.$touch()
        if (this.$v.$invalid) return
        const payload = this.staticContent.reduce((acc, el) => {
            if (el.name === 'registration-attendee') {
              acc.id = el.id
              acc.name = el.name
              acc.metadata.RACategoryPlaceholder.content = this.categoryPlaceholder
            }
            return acc
          }, {
            metadata: {
              RACategoryPlaceholder: {
                content: '',
                label: 'Category placeholder',
                type: 'input'
              }
            }
          }
        )
        await this.updatePlaceholderValue(payload)
        this.$v.categoryPlaceholder.$reset()
      },
      isPlaceholderExists (el) {
        if (el.name === 'registration-attendee') {
          return !!el.metadata.RACategoryPlaceholder.content
        }
      }
    },
    mounted () {
      this.fetchStaticContent()
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Settings/PlaceholderTextSettings.vue